import React, { useContext } from "react";
import { ThemeContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import Logo from "../../images/Logo.png";

const Footer = () => {
    const { dark } = useContext(ThemeContext);
    const { t } = useTranslation();
    return (
        <div className={`footer brand-wrapper ${dark ? "dark" : ""}`}>
            <img
                src={Logo}
                className="logo"
                alt={t("common.popLogoAlt")}
            />
        </div >
    );
};

export default Footer;